import { render, staticRenderFns } from "./FormBuilderElement.vue?vue&type=template&id=c14bb334&scoped=true&lang=pug&"
import script from "./FormBuilderElement.vue?vue&type=script&lang=js&"
export * from "./FormBuilderElement.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderElement.vue?vue&type=style&index=0&id=c14bb334&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14bb334",
  null
  
)

/* custom blocks */
import block0 from "./FormBuilderElement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports